











import { Component, Vue } from "vue-property-decorator"
import CatalogItem from './CatalogItem.vue'
import content from '../services/ContentService'
// import Rellax from 'rellax'

@Component({
  components: {
    CatalogItem,
  }
})
export default class CatalogView extends Vue {
  public catalog = content.catalog

  mounted () {
    // Vue.nextTick(() => new Rellax())
  }

}
